import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[numeric]'
})

export class NumericDirective {

    static parameters = [ElementRef];

    @Input('numericType') numericType: string; // number | decimal | percent
    @Input('numericDigit') numericDigit: Number = 2; // Digit Default 2
    @Input('minvalue') minvalue: Number = null; // Min Value Default NULL
    @Input('maxvalue') maxvalue: Number = null; // Max Default NULL
    @Input('allowNigative') allowNigative: boolean = false; // Max Default NULL

    private regex = {
        number: new RegExp(/^\d+$/),
        decimal: new RegExp(/^[0-9]+(\.[0-9]*){0,1}$/g),
        percent: new RegExp(/^\d{0,2}\.?\d{0,2}$/g)
    };

    private specialKeys = {
        number: ['Backspace', 'Delete', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight'],
        decimal: ['Backspace', 'Delete', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight'],
        percent: ['Backspace', 'Delete', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight'],
    };

    constructor(private el: ElementRef) {
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {

        if (this.specialKeys[this.numericType].indexOf(event.key) !== -1) {
            return;
        }
        // Do not use event.keycode this is deprecated.
        // See: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
        // let current: string = this.el.nativeElement.value;
        // let next: string = current.concat(event.key);
        // if (next && !String(next).match(this.regex[this.numericType])) {
        //     event.preventDefault();
        // }
        let current: string = this.el.nativeElement.value;
        const position = this.el.nativeElement.selectionStart;
        let next: string = '';
        if (this.numericType == "percent") {
            if (!(this.el.nativeElement.selectionStart == this.el.nativeElement.selectionEnd)) {
                current = "";
            }
            next = [current.slice(0, position), event.key == "Decimal" ? "." : event.key, current.slice(position)].join("");
            const beforeDecimal: any = next.split(".")[0];
            const AfterDecimal: any = next.split(".")[1];
            const checkDotFirstPosition: string = next.substring(0, 1);
            if (next === "00") {
                event.preventDefault();
            }
            if (checkDotFirstPosition === ".") {
                // event.preventDefault();
                this.el.nativeElement.value = "";
                setTimeout(() => {
                    current = "0";
                    this.el.nativeElement.value = "0.";
                }, 100);
            }
            if (beforeDecimal) {
                if (beforeDecimal <= 100) {
                    if (beforeDecimal.toString().length >= 4) {
                        event.preventDefault();
                    }
                } else {
                    if (beforeDecimal.toString().length >= 3) {
                        event.preventDefault();
                    }
                }
            }
            if (AfterDecimal) {
                if (AfterDecimal.toString().length >= 3) {
                    event.preventDefault();
                }
            }
            if (next && !String(next).match(this.regex[this.numericType])) {
                event.preventDefault();
            }
        } else {
            next = [current.slice(0, position), event.key, current.slice(position)].join("");
            let next1 = next;
            if (this.allowNigative) {
                const checkNegativeFirstPosition: string = next.substring(0, 1);
                if (next && checkNegativeFirstPosition == '-') {
                    next = next.replace(checkNegativeFirstPosition, '');
                }
            }
            if (next) {
                var SplitNumeric = next.split('.');
                if (!String(next).match(this.regex[this.numericType]) || (SplitNumeric.length > 1 && Number(SplitNumeric[1].length) > Number(this.numericDigit)) || this.CheckMinValue(Number(next1)) || this.CheckMaxValue(Number(next1))) {
                    event.preventDefault();
                }
            }
        }
    }

    CheckMinValue(Val) {
        if (this.minvalue == null) {
            return false;
        }
        if (Val >= this.minvalue) {
            return false;
        }
        return true;
    }

    CheckMaxValue(Val) {
        if (this.maxvalue == null) {
            return false;
        }
        if (Val <= this.maxvalue) {
            return false;
        }
        return true;
    }
}